import Vue from "vue";
import router from "@/router";
import * as Sentry from "@sentry/vue";
import { BrowserTracing } from "@sentry/tracing";

if (process.env.VUE_APP_ENVIRONMENT !== "local") {
  Sentry.init({
    Vue,
    dsn:
      "https://14247df6b17c438681a627e179f96bdc@o312973.ingest.sentry.io/5448573",
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ["app.kymatio.com", "develop.kymatio.xyz"]
      })
    ],
    environment: process.env.VUE_APP_ENVIRONMENT,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  });
}
